export default "__VITE_ASSET__C5nZ2skx__"